import React from 'react';
import Banner from '../Banner/Banner';
import Departments from '../Departments/Departments/Departments';

const Home = () => {
    return (
        <div>
            <Banner></Banner>
            <Departments></Departments>
        </div>
    );
};

export default Home;